import * as React from "react";
import { ComponentsState, ErrorComponentsState } from "piral";
import { Link } from "react-router-dom";
import { MainContentContainer } from "./components/MainContentContainer";
import { MenuItem } from "./components/HeaderContainer";

export const errors: Partial<ErrorComponentsState> = {
  not_found: () => (
    <div>
      <p className="error">
        De pagina is niet gevonden.{" "}
        <a href="https://www.hetcak.nl">Klik hier om naar de CAK website te gaan.</a>
      </p>
    </div>
  )
};

export const layout = (enabled = false): Partial<ComponentsState> => ({
  Layout: ({ children }) => (
    <MainContentContainer coBrowsingEnabled={enabled}>{children}</MainContentContainer>
  ),
  MenuContainer: ({ children }) => <>{children}</>,
  MenuItem,
  LoadingIndicator: () => (
    <MainContentContainer coBrowsingEnabled={false}>
      <div className="col-12 offset-lg-2 col-lg-8 p-0 min-vh-100">
        <div className="loading-app-shell pt-4">
          <span className="loader" />
        </div>
      </div>
    </MainContentContainer>
  )
});
